import React from 'react'
import RaceFlyerEmailForm from '../../Components/RaceFlyerEmailForm/RaceFlyerEmailForm'

export default function EmailRaceFlyer() {

  return (
    <div className='race-flyer-page-wrapper'><RaceFlyerEmailForm/></div>
  )
}
